export default {
  private: false,
  template_name: 'Dropdown',
  allowed_types: [
    'gh_element'
  ],
  model: {
    template_id: 'gh_dropdown',
    name: 'Dropdown',
    icon_id: 'dropdown',
    class: 'gh_col_height_0 gh_height_percent gh_width_percent vertical_scroll gh_col_width_0',
    priority: 0,
    container_id: 0,
    content: [
      {allowed_types: ['gh_element'], template_id: 'gh_float', name: '', icon_id: '', class: '', priority: 0, container_id: 0, content: []}
    ]
  },
  container_settings: [{
    group: 'Width',
    name: 'Width +',
    icon: 'plus',
    function: 'sizeChange',
    arg: 'width plus'
  }, {
    group: 'Width',
    name: 'Width -',
    icon: 'minus',
    function: 'sizeChange',
    arg: 'width minus'
  }, {
    group: 'Width',
    name: 'Width Clear',
    icon: 'rubbish',
    function: 'sizeChange',
    arg: 'width clear'
  },{
    name: 'Delete Dropdown',
    icon: 'rubbish',
    function: 'deleteContainer'
  }],
  html:
    /*html */`
    <div class="gh_dropdown" ng-init="lists = item.content;">
      <div class="edit_template_container_form">
        <pencil-container-settings parent="$parent.lists" lists="item.content" item="item"></pencil-container-settings>
      </div>
      <div class="dropdown_wrapper" ng-click="opened = !opened; opened && positionDropdownMenu($event)" ng-class="{opened: opened}">

      <span ng-click="setIcon(item)" class="gh_tabs_block_nav_btn_icon" gh-icon="{{item.icon_id ? item.icon_id : 'box'}} 0D99FF 30px normal"></span>
      <input class="gh_dropdown_name" type="text" ng-model="item.name"/>
      <span class="caret" gh-icon="bot_arrow 7f7f7f 15px normal"></span>

      <div class="dropdown_elements">
        <div class="drag_placeholder" ng-show="!item.content[0].content.length">
          <span> Drag Element </span>
        </div>
        <div ng-class="item.class" class="container_wrapper" ng-repeat="item in lists" ng-include="item.template_id + '_editor'"></div>
      </div>
      </div>
    </div>
    `,
  icon: 'dropdown'
};
